import { render, staticRenderFns } from "./investigation.vue?vue&type=template&id=27f22ff2&scoped=true&"
import script from "./investigation.vue?vue&type=script&lang=js&"
export * from "./investigation.vue?vue&type=script&lang=js&"
import style0 from "./investigation.vue?vue&type=style&index=0&id=27f22ff2&scoped=true&lang=css&"
import style1 from "./investigation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f22ff2",
  null
  
)

export default component.exports